import { IBestPricePrices, IBookedTrips, IBooking } from "../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";



export class FavouriteDepartureContext {


    public routeTo: string[] = [];
    public selectedTripForTest: Partial<IBookedTrips> = {}
    public bestPrices: IBestPricePrices[] = []
    public calendarDayInterval: number = 180
    public continueToCheckout: boolean = false    

    public roundOutboundPrebookData: undefined | IBooking = undefined
    public roundOutboundDateSelected: string = ""
    public uniqueOffers: string[] = []

    public actionResult: Partial<IDefaultActionResult> = {}

    constructor() {

    }
}